import { Theme } from '@mui/material/styles';

const styles = (theme: Theme) => ({
  headerOption: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '14px',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    color: theme.palette.primary.main,
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '5px 10px',
    minHeight: 'auto',
    textTransform: 'capitalize',
    '&.MuiButton-root': {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      '&:hover': {
        backgroundColor: theme.palette.secondary.light,
        color: theme.palette.secondary.main,
        borderRadius: '8px',
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.secondary.main,
      borderRadius: '6px',
    },
  },
  searchInput: {
    marginLeft: 'auto',
    width: '100%',
    maxWidth: '250px',
    [theme.breakpoints.down(1350)]: {
      maxWidth: '180px',
    },
    [theme.breakpoints.down(1235)]: {
      maxWidth: '150px',
    },
  },
  searchWrapper: {
    marginLeft: 'auto',
  },
});

export default styles;
